import { type ReactNode } from 'react';

import { Box, type SxProps, type Theme, Typography } from '@mui/material';

import { headerTextSx, mutedTextSx, titleSx } from './analytics.styles';

type SubsectionHeaderProps = Readonly<{
  title: string;
  subtitle: string;
  /** Sits beside the title, dropping below it once the row is too narrow. */
  action?: ReactNode;
}>;

/** Nests under a PageHeader-titled section. */
export const SubsectionHeader = ({ title, subtitle, action }: SubsectionHeaderProps) => {
  const heading = (
    <Box sx={headerTextSx}>
      <Typography variant="text-lg-semibold" sx={titleSx}>
        {title}
      </Typography>
      <Typography variant="text-sm-regular" sx={mutedTextSx}>
        {subtitle}
      </Typography>
    </Box>
  );

  if (!action) return heading;

  return (
    <Box sx={headerRowSx}>
      {heading}
      <Box sx={actionSx}>{action}</Box>
    </Box>
  );
};

const headerRowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: backrs.spacing['spacing-xl'],
  width: '100%',
  '@container (min-width: 650px)': {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
});

const actionSx: SxProps<Theme> = {
  display: 'flex',
  flexShrink: 0,
};
